import React from 'react';

function Footer() {
  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-4 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center">
        <a
          href="mailto:Peter.Bosch@rotary6270.org?subject=Feedback"
          className="text-sm text-[#005DAA] hover:text-[#004A8F] hover:underline"
          data-testid="feedback-link"
        >
          Report Bug / Request Feature
        </a>
      </div>
    </footer>
  );
}

export default Footer;
